import React from 'react';
import CrudPage from '../../components/CrudPage';
import { currencyApi } from '../../services/adminApi';

const columns = [
  { header: 'ID', field: 'currencyId' },
  { header: 'Currency Name', field: 'currencyName' },
  { header: 'Symbol', field: 'currencySymbol' },
  { header: 'Exchange Rate (GBP)', field: 'convertionRateGPB' },
];

const formFields = [
  { name: 'currencyName', label: 'Currency Name', type: 'text', required: true },
  { name: 'currencySymbol', label: 'Symbol', type: 'text', required: true },
  { name: 'convertionRateGPB', label: 'Exchange Rate (GBP)', type: 'number', step: '0.0001' },
];

const CurrencyPage = () => (
  <CrudPage
    title="Currencies"
    subtitle="Manage currencies"
    api={currencyApi}
    columns={columns}
    formFields={formFields}
    idField="currencyId"
    searchField="currencyName"
  />
);

export default CurrencyPage;
